<template>
  <svg :width="width" :height="height" >
    <g v-if="layout" :transform="layoutTransform" >
      <text
         v-for="word in words"
         :fill="color(word)"
         :style="{'font-size': word.size + 'px'}"
         text-anchor="middle"
         :transform="'translate(' + word.x + ',' + word.y + ') rotate(' + word.rotate + ')'" >
        {{ word.text }}
      </text>
    </g>
  </svg>
</template>

<script>
import * as d3 from 'd3'
import cloud from 'd3-cloud'

export default {
  props: {
    data: {
      required: true,
      type: Array
    },
    width: {
      required: true,
      type: Number
    },
    height: {
      required: true,
      type: Number
    },
    rotate: {
      type: Function,
      default: () => (~~(Math.random() * 6) - 3) * 30
    },
    padding: {
      type: Function,
      default: () => 5
    },
    color: {
      type: Function,
      default: () => {
        const colors = [
          '#a6cee3',
          '#1f78b4',
          '#b2df8a',
          '#33a02c',
          '#fb9a99',
          '#e31a1c',
          '#fdbf6f',
          '#ff7f00',
          '#cab2d6',
          '#6a3d9a',
          '#ffff99',
          '#b15928'
        ]
        return colors[Math.floor(Math.random() * colors.length)]
      }
    },
    font: {
      type: Function,
      default: () => 'serif'
    },
    minFontSize: {
      type: Number,
      default: 10
    },
    maxFontSize: {
      type: Number,
      default: 80
    }
  },
  data () {
    return {
      words: [],
      layout: null
    }
  },
  mounted () {
    this.update()
  },
  watch: {
    data () {
      this.update()
    },
    width () {
      this.update()
    },
    height () {
      this.update()
    }
  },
  computed: {
    layoutTransform () {
      return `translate(${this.layout.size()[0] / 2},${this.layout.size()[1] / 2})`
    }
  },
  methods: {
    update () {
      let min = null
      let max = null
      this.words.splice(0, this.words.length, ...this.data.map(d => {
        if (min === null || min > d.size) {
          min = d.size
        }
        if (max === null || max < d.size) {
          max = d.size
        }
        return {
          text: d.text,
          size: d.size
        }
      }))
      this.scale = d3
        .scaleLinear()
        .range([this.minFontSize, this.maxFontSize])
        .domain([min, max])
      this.layout = cloud()
        .size([this.width, this.height])
        .words(this.words)
        .rotate(this.rotate)
        .padding(this.padding)
        .fontSize(d => this.scale(d.size))
        .font(this.font)
        .start()
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/CloudTag.vue